import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css', './../home.component.css']
})
export class HelpComponent implements OnInit {

  shopUrl = environment.shopUrl;
  constructor() { }

  ngOnInit(): void {
  }

}
